import { render, staticRenderFns } from "./hqSettings.vue?vue&type=template&id=20ce224a&scoped=true&"
import script from "./hqSettings.vue?vue&type=script&lang=js&"
export * from "./hqSettings.vue?vue&type=script&lang=js&"
import style0 from "./hqSettings.vue?vue&type=style&index=0&id=20ce224a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce224a",
  null
  
)

export default component.exports